import { Component, ErrorHandler, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-consultancyform',
  templateUrl: './consultancyform.component.html',
  styleUrls: ['./consultancyform.component.css']
})
export class ConsultancyformComponent implements OnInit {
  mode: any;
  PR_Id: any;
  title = 'Consultancy Details';
  data: any;
  C: any = {};
  ClinicalDiscipline: any = [];
  ClinicalDisciplineData: any;
  Specializationlist: any = [];
  SpecializationData: any;
  Hospital: any = [];
  HospitalData: any;
  temp: any = {};
  PrescriptionList: any = [];
  PL: any = {};
  docorlist: any =[];
  fileToUpload: File;
  Prescription: any;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }
  
  ngOnInit() {
    this.GetClinicalDisciplineDropDown();
    this.GetConsultancySpecializationDropDown();
    this.GetConsultancyHospitalDropDown();

    this.route.params.subscribe(params => {
      this.PR_Id = params['PR_Id'];
      this.mode = params['mode'];

      if (this.PR_Id > 0) {

        this.GetByIdConsultancyDetails(this.PR_Id)
      }
    });
    if (this.mode == 'View') {
      this.title = "View Consultancy ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Consultancy ";
    }
  }

  GetClinicalDisciplineDropDown() {
    this.ClinicalDisciplineData = this.userService.GetClinicalDisciplineDropDown();
    this.ClinicalDisciplineData.subscribe(
      (Resp: any) => {
        this.ClinicalDiscipline = Resp.Result;
      }
    )
  }

  GetConsultancySpecializationDropDown() {
    this.SpecializationData = this.userService.GetConsultancySpecializationDropDown();
    this.SpecializationData.subscribe(
      (Resp: any) => {
        this.Specializationlist = Resp.Result;
      }
    )
  }

  GetConsultancyHospitalDropDown() {
    this.HospitalData = this.userService.GetConsultancyHospitalDropDown();
    this.HospitalData.subscribe(
      (Resp: any) => {
        this.Hospital = Resp.Result;
      }
    )

    this.HospitalData = this.userService.GetDoctorDropDownlist();
    this.HospitalData.subscribe(
      (Resp: any) => {
        this.docorlist = Resp.Result;
      }
    )
  }

  GetByIdConsultancyDetails(PR_Id) {
    debugger;
    this.Prescription = this.PrescriptionList;
    this.data = this.userService.GetByIdConsultancyDetails(PR_Id);
    this.data.subscribe(
      (response: any) => {
        this.C = response;
     
      }, (error) => {
      });
  }

  AddPrescriptionDetails(PL) {
    debugger;
    this.temp = {
      Description: PL.Description,
      Course: PL.Course,
      Dosage: PL.Dosage,
    }
    //covarhge ddl
    this.PrescriptionList.push(this.temp);
    this.PL = {};
  }

  PrescriptionDetailsremove(i) {
    swal({
      title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
    })
    this.PrescriptionList.splice(i, 1);
  }

  CreateConsultancyDetails(Consultancy) {
    debugger;
    Consultancy.PR_Id=this.PR_Id;
    Consultancy.VI_Id =this.C.VI_Id;
    Consultancy.PrescriptionList = this.PrescriptionList;
    this.data = this.userService.CreateConsultancyDetails(Consultancy);
    this.data.subscribe(
      (response) => {
        swal('Success!', 'Consultancy Details Added Successfully .', 'success');
        this.router.navigate(['/home/consultancy']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }



  
  imageUpload(file: FileList) {
    debugger;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|JPEG|JPG)$/;   
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData(); 
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImageRecovery(data);
          x.subscribe(
            (response) => {
            }, (error) => {
              let i: any = document.getElementById('DO_Photo');
              i.value = "";
              if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('DO_Photo');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }

      getimageUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('DO_Photo');
          return imagename.files[0].name;
        }
        catch (e) {
          return null; 
        }
      }

}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/consultancy/consultancyform/consultancyform.component.ts